import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Nunca pensé que podría proteger a mi familia y ahorrar al mismo tiempo. Mi asesor me explicó todo en español y ahora tengo tranquilidad.',
  name: 'María G.',
  descriptor: 'Madre de familia, Houston TX',
  initials: 'MG',
  color: 'bg-blue-100 text-blue-700'
}, {
  quote: 'Llevo 3 años con mi IUL y mis ahorros han crecido cada año sin perder un centavo. Es la mejor decisión financiera que he tomado.',
  name: 'Carlos R.',
  descriptor: 'Empresario, Miami FL',
  initials: 'CR',
  color: 'bg-green-100 text-green-700'
}, {
  quote: 'Cuando me diagnosticaron una enfermedad, pude acceder a mis beneficios en vida. Mi familia nunca quedó desprotegida.',
  name: 'Ana L.',
  descriptor: 'Profesional, Los Angeles CA',
  initials: 'AL',
  color: 'bg-purple-100 text-purple-700'
}];
export function Testimonials() {
  return <section className="py-24 bg-white relative" data-id="element-115">
      <div className="max-w-7xl mx-auto px-6" data-id="element-116">
        <div className="text-center mb-16" data-id="element-117">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-3xl md:text-4xl font-bold text-deep-blue mb-4" data-id="element-118">
            Historias de éxito reales
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-gray-600 max-w-2xl mx-auto text-lg" data-id="element-119">
            Únete a cientos de familias hispanas que ya están asegurando su
            futuro financiero.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-120">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-light-bg p-8 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow duration-300 flex flex-col h-full" data-id="element-121">
              <div className="flex gap-1 mb-6" data-id="element-122">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-123" />)}
              </div>
              <p className="text-gray-700 italic mb-8 flex-grow leading-relaxed" data-id="element-124">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-4 mt-auto" data-id="element-125">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg ${testimonial.color}`} data-id="element-126">
                  {testimonial.initials}
                </div>
                <div data-id="element-127">
                  <h4 className="font-bold text-deep-blue" data-id="element-128">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-gray-500" data-id="element-129">
                    {testimonial.descriptor}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}